import { render } from "./VideoScriptAppBasicDetails.vue?vue&type=template&id=73c1df38&lang=true"
import script from "./VideoScriptAppBasicDetails.vue?vue&type=script&lang=js"
export * from "./VideoScriptAppBasicDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__